import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D80027",
      d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F0F0F0",
      d: "M12.174 6.609H9.391V3.826H6.61V6.61H3.826V9.39H6.61v2.783H9.39V9.391h2.783z"
    }, null, -1)
  ])))
}
export default { render: render }